import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { useCountry } from '../../components/CountrySelector';
import { useOrderSummary } from '../useOrderSummary';
import { UpdateOrderAction, OrderState } from '../useUpdateOrder';
import {
  UpdateOrderPaymentMethodMutation,
  UpdateOrderPaymentMethodMutationVariables,
  UPDATE_ORDER_PAYMENT_METHOD_MUTATION
} from './useUpdateOrderPaymentMethod.rest';

export const useUpdateOrderPaymentMethod = (orderNumber: string) => {
  const {
    country: { alpha3Code }
  } = useCountry();

  const { orderSummary } = useOrderSummary(orderNumber);

  const [mutate, { loading, error }] = useMutation<
    UpdateOrderPaymentMethodMutation,
    UpdateOrderPaymentMethodMutationVariables
  >(UPDATE_ORDER_PAYMENT_METHOD_MUTATION);

  const updateOrderPaymentMethod = useCallback(
    (selectedPaymentId: number) => {
      if (!orderSummary)
        return Promise.reject('updateOrderPaymentMethod: orderSummary is not fetched');

      return mutate({
        variables: {
          orderId: orderSummary.id,
          input: {
            data: {
              action_type: UpdateOrderAction.ChangePayment,
              id: orderSummary.id,
              type: 'orders',
              attributes: {
                country_code: alpha3Code,
                order_state: OrderState.Default,
                selected_payment_id: selectedPaymentId
              }
            }
          }
        }
      });
    },
    [alpha3Code, mutate, orderSummary]
  );

  return { updateOrderPaymentMethod, loading, error };
};
